var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    fill: "#808080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M935.6,173.3h-54.4v-54.4c0-29.9-24.5-54.4-54.4-54.4H64.4C34.5,64.4,10,88.9,10,118.9v653.3c0,29.9,24.5,54.4,54.4,54.4h54.4v54.4c0,29.9,24.5,54.4,54.4,54.4h762.2c29.9,0,54.4-24.5,54.4-54.4V227.8C990,197.8,965.5,173.3,935.6,173.3z M118.9,227.8v544.4H64.5c0,0-0.1-0.1-0.1-0.1V119c0,0,0.1-0.1,0.1-0.1h762c0,0,0.1,0.1,0.1,0.1v54.3H173.3C143.4,173.3,118.9,197.8,118.9,227.8L118.9,227.8z M935.6,881C935.5,881,935.5,881.1,935.6,881l-762.1,0.1c0,0-0.1-0.1-0.1-0.1V227.9c0,0,0.1-0.1,0.1-0.1h762c0,0,0.1,0.1,0.1,0.1V881z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.7,363.9c0,45.1-36.6,81.7-81.7,81.7c-45.1,0-81.7-36.6-81.7-81.7c0-45.1,36.6-81.7,81.7-81.7C790.1,282.2,826.7,318.8,826.7,363.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.1,826.7H227.8V717.8l190.6-326.7l217.8,272.2h54.4L881.1,500V826.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.7fb8264555609cc2c88c1490aa36d609.svg";
export { ForwardRef as ReactComponent };